import { compose, withProps } from 'recompose';
import { get } from 'lodash';
import withSelfStorageSchema from '@sparefoot/react-core/decorators/withSelfStorageSchema';
import { mapAmenitiesToFeature } from '../config/amenityMap';
import { getRoundedRating } from '../utils/rating';

export default compose(
	withProps(
		({ facility, units, reviewCount, average, facilityUrl, baseUrl }) => {
			const amenityFeature = mapAmenitiesToFeature(facility) || [];
			const { promotion, cloudfrontUrl, images, phone, location } =
				facility;
			let imagesWithUrl = [];
			// Fallback to facility.units if units prop not provided
			const resolvedUnits = units ?? facility.units;

			// Resolve promotion: use facility.promotion if available, otherwise find first unit with promotion
			let schemaPromotion = promotion || '';
			if (!schemaPromotion.length && resolvedUnits?.length) {
				const unitPromotion = resolvedUnits.find(
					(unit) => unit.promotion?.length
				);
				schemaPromotion = get(unitPromotion, 'promotion', '');
			}


			if (images?.length) {
				imagesWithUrl = images.map(
					(image) =>
						`${cloudfrontUrl ? 'https:' : ""}${cloudfrontUrl ?? baseUrl}/large-compress/${image}`,
				);
			}

			
			// Fallback to facility.reviewMetadata when explicit props not provided
			// Apply getRoundedRating to fallback average for consistency with search FacilityCard
			const resolvedReviewCount = reviewCount ?? facility.reviewMetadata?.count;
			const fallbackAverage = facility.reviewMetadata?.average;
			const resolvedAverage = average ?? (fallbackAverage != null ? getRoundedRating(fallbackAverage) : undefined);
			// Fallback to facility.url.facility when facilityUrl prop not provided
			const resolvedFacilityUrl = facilityUrl ?? facility.url?.facility ?? '';

			return {
				facility: {
					...facility,
					name: facility.name,
					...(imagesWithUrl.length > 0
						? { image: imagesWithUrl }
						: {}),
					location: {
						...location,
						streetAddress1: location.streetAddress,
					},
					facilityPhone: phone,
					imagesWithUrl,
					reviews: {
						...facility.reviews,
						number: resolvedReviewCount,
						average: resolvedAverage,
					},
					schemaUrl: `${baseUrl}${resolvedFacilityUrl}`,
					amenityFeature,
				},
				schemaPromotion,
			};
		}
	),
	withSelfStorageSchema
);
